export const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://127.0.0.1:5000';
export const resolveImg = (url: string) => {
  if (!url) return '';
  // Strip any explicit domain so we can rely on relative proxy mapping
  url = url.replace(/http:\/\/(127\.0\.0\.1|localhost|44\.212\.99\.135):5000/g, '');
  if (url.startsWith('http')) return url;
  return url.startsWith('/') ? url : `/${url}`;
};

